/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */

/**
 * @namespace SpinePluginEvents
 */

module.exports = {

    COMPLETE: require('./COMPLETE_EVENT'),
    DISPOSE: require('./DISPOSE_EVENT'),
    END: require('./END_EVENT'),
    EVENT: require('./EVENT_EVENT'),
    INTERRUPTED: require('./INTERRUPTED_EVENT'),
    START: require('./START_EVENT')

};
